var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"no-data-exists d-flex flex-column justify-content-center align-items-center"},[_c('p',{staticClass:"text-muted m-0",attrs:{"id":"noContentText"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }